var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinFormulationVariants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.65308L5.20002 7.83676L3.00004 8.449V9.67349L7 8.65308Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.102L5.20002 10.2857L3.00004 10.898V12.1225L7 11.102Z",
    fill: "#313131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.551L5.40002 12.7347L3.00004 13.347V14.5714L7 13.551Z",
    fill: "#313131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.22449V6L6.99996 7.42857L7 8.65308L3 7.22449Z",
    fill: "#313131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00004 9.67349V8.449L6.99996 9.87755L7 11.102L3.00004 9.67349Z",
    fill: "#313131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00004 12.1225V10.898L6.99996 12.3265L7 13.551L3.00004 12.1225Z",
    fill: "#313131"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00004 14.5714V13.347L6.99996 14.7755V16L3.00004 14.5714Z",
    fill: "#313131"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.30617L11.85 5.67351L8.00007 6.898V9.34698L15 7.30617Z",
    fill: "#313131"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.2041L11.85 10.5714L8.00007 11.7959V14.2449L15 12.2041Z",
    fill: "#313131"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.1021L12.2 15.4694L8.00007 16.6939V19.1429L15 17.1021Z",
    fill: "#313131"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.44898V2L14.9999 4.85714L15 7.30617L8 4.44898Z",
    fill: "#313131"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00007 9.34698V6.898L14.9999 9.7551L15 12.2041L8.00007 9.34698Z",
    fill: "#313131"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00007 14.2449V11.7959L14.9999 14.6531L15 17.1021L8.00007 14.2449Z",
    fill: "#313131"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00007 19.1429V16.6939L14.9999 19.551V22L8.00007 19.1429Z",
    fill: "#313131"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.1837L18.75 8.20411L16 8.9388V10.4082L21 9.1837Z",
    fill: "#313131"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.1225L18.75 11.1429L16 11.8776V13.3469L21 12.1225Z",
    fill: "#313131"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.0612L19 14.0817L16 14.8163V16.2857L21 15.0612Z",
    fill: "#313131"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.46939V6L21 7.71428L21 9.1837L16 7.46939Z",
    fill: "#313131"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4082V8.9388L21 10.6531L21 12.1225L16 10.4082Z",
    fill: "#313131"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.3469V11.8776L21 13.5918L21 15.0612L16 13.3469Z",
    fill: "#313131"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.2857V14.8163L21 16.5306V18L16 16.2857Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinFormulationVariants);
export default __webpack_public_path__ + "static/media/ProteinFormulation_Variants.4d870f6ddaab168928b9761da3c87d47.svg";
export { ForwardRef as ReactComponent };